import { Button } from '@flippingbook/web.react-kit/dist/Button';
import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import { Link as KitLink } from '@flippingbook/web.react-kit/dist/Link';
import { Paper } from '@flippingbook/web.react-kit/dist/Paper';

import { useRestoreStartPage } from '@/hooks/useRestoreStartPage';
import { loc } from '@/localization';
import { discoveryService } from '@/services/instance/discovery';
import { Field } from '@/site/components/Field';
import { Link } from '@/site/components/Link';

import { b, e } from '../../Login/style.css';

import { SuccessMessagePage } from './success-message';

const siteUrl = discoveryService.get('site');

export function StartPage() {
    const { loginUrl, successEmail, register, errors, cleanErrors, onFormSubmit, isSubmitting, validationRules } =
        useRestoreStartPage();

    return !successEmail ? (
        <div className={b.name}>
            <Paper
                className={e.card}
                radius="large"
            >
                <h1 className={e.title}>{loc.Login.RestorePassword}</h1>
                <p className={e.subtitle2}>{loc.Login.RestorePasswordFormDescription}</p>
                <div className={e.form}>
                    <form
                        onSubmit={onFormSubmit}
                        noValidate
                    >
                        <Field
                            className={e.emailField}
                            name="email"
                            type="email"
                            placeholder={loc.Login.WorkEmail}
                            register={register}
                            errors={errors}
                            validationRules={validationRules}
                            readOnly={isSubmitting}
                            onChange={cleanErrors}
                            autoFocus
                        />
                        <div className={e.buttons}>
                            <Button
                                className={e.submitButton}
                                type="submit"
                                theme="green"
                                size="large"
                                progress={isSubmitting}
                                disabled={isSubmitting}
                            >
                                {loc.Login.DoResetPassword}
                            </Button>
                        </div>
                    </form>
                </div>
                <div className={e.footer}>
                    <p>{loc.Login.DontHaveAccess}</p>
                    <p>
                        <KitLink href={`${siteUrl}contacts?contact-form=support`}>
                            {loc.Login.ContactOurSupportTeam}
                        </KitLink>
                    </p>
                </div>
                <div className={e.footer}>
                    <p>
                        <L10n
                            text={loc.Login.RestoreAlreadyHaveAnAccount}
                            replaces={[
                                [
                                    '{doLogin}',
                                    <Link
                                        to={loginUrl}
                                        reloadDocument
                                    >
                                        {loc.Login.DoLogin.toLowerCase()}
                                    </Link>,
                                ],
                            ]}
                        />
                    </p>
                </div>
            </Paper>
        </div>
    ) : (
        <SuccessMessagePage email={successEmail} />
    );
}
